import { render, staticRenderFns } from "./WatchlistPageContainer.vue?vue&type=template&id=59230480&"
import script from "./WatchlistPageContainer.vue?vue&type=script&lang=js&"
export * from "./WatchlistPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports